const REQUIRED_RATIO = 380 / 600;

export const hasExactRatio = (width, height) => {
    return (width / height) === REQUIRED_RATIO;
};